module.exports = __webpack_public_path__ + "img/shilenDanc.6599da2d.png";